/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ContinuousDeploymentSlackMessageRequest} from '@cash-web/protos/squareup/cash/cashdotapp/api.pb'
import {ContinuousDeploymentSlackMessageResponse} from '@cash-web/protos/squareup/cash/cashdotapp/api.pb'


export const continuousDeploymentSlackMessage = (request: ContinuousDeploymentSlackMessageRequest, options?: CashRequestOptions) => post<ContinuousDeploymentSlackMessageRequest, ContinuousDeploymentSlackMessageResponse>("/2.0/cash/continuous-deployment-slack-message", request, {...options, rejectOnError: true })